module.exports = __webpack_public_path__ + "static/img/white-avatar.55b3731.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activityManage/white-avatar.svg
// module id = Wasb
// module chunks = 1